module.exports = __webpack_public_path__ + "static/media/icon_instrument_acoustic_guitar.8b9301fa.svg";